import { NgModule } from '@angular/core';
import { ProjectsRoutingModule } from './projects-router.module';
import { ManageProjectsModule } from "./manage-projects/manage-projects.module";
import { InverterPlanModule } from "./inverter-plan/inverter-plan.module";
import { RoofPlanModule } from "./roof-plan/roof-plan.module";
import { CreateProjectModule } from "./create-project/create-project.module";

@NgModule({
  declarations: [
  ],
  imports: [
    ProjectsRoutingModule,
    ManageProjectsModule,
    InverterPlanModule,
    RoofPlanModule,
    CreateProjectModule
  ],
  exports: [
  ]
})
export class ProjectsModule { }
